import Marquee from "react-fast-marquee";

export default function TrustStrip() {
  const items = [
    "WE LOVE XERO",
    "FULLY REMOTE NZ TAX PRACTICE",
    "PROSAIC FOR SOLE TRADERS",
    "GOODBYE PAPER, HELLO TECHNOLOGY",
    "TAXATION MADE EASY",
    "REGISTERED IN TE ATATU · AUCKLAND",
  ];
  return (
    <section className="border-y border-slate-200 bg-slate-50 overflow-hidden" data-testid="trust-strip">
      <Marquee speed={38} gradient={false} pauseOnHover>
        <div className="flex items-center gap-12 md:gap-24 py-6 pr-12 md:pr-24">
          {items.concat(items).map((text, i) => (
            <div key={i} className="flex items-center gap-12 md:gap-24">
              <span className="font-heading font-black text-xs md:text-sm uppercase tracking-[0.22em] text-slate-700 whitespace-nowrap">
                {text}
              </span>
              <span className="w-1.5 h-1.5 bg-[#C9A349] rotate-45" aria-hidden />
            </div>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
